import { z } from "zod";

export const RCNumberSchema = z.object({
  rcNumber: z.string().min(5, "RC Number is required"),
});

export const LoginSchema = z.object({
  employerCode: z
    .string()
    .min(5, "Invalid employer code")
    .max(12, "Employer code must be 12 characters or less")
    .optional()
    .nullable(),
  emailAddress: z.email("Invalid email address").optional().nullable(),
});

export const VerifyCompanyDetailsSchema = z.object({
  verifyCompanyDetails: z.boolean().refine((value) => value, {
    message: "You must confirm these company details are correct",
  }),
  cacCertificateUrl: z.string().min(5, "Your Certificate is required"),
  incorporationDate: z.string().min(1, "Incorporation Date is required"),
});

export const OTPVerificationSchema = z.object({
  otp: z.string().min(6, "OTP must be 6 digits").max(6, "OTP must be 6 digits"),
});

export const EmployerCodeRegistrationSchema = z.object({
  employerCode: z.string().min(5, "Employer Code is required"),
});

export const EmployerDetailsSchema = z.object({
  companyName: z.string().min(1, "Company Name is required"),
  rcNumber: z.string().min(1, "RC Number is required"),
  companyType: z.string().min(1, "Company Type is required"),
  emailAddress: z.string().email("Invalid email address"),
  employerAddress: z.string().min(1, "Employer Address is required"),
  phoneNumber: z.string().min(10, "Phone Number is required"),
  directorName: z.string().min(1, "Director Name is required"),
  directorEmail: z.string().email("Invalid director email address"),
  sectorCode: z.string().min(1, "Sector Code is required"),
  tinNumber: z.string().min(1, "TIN Number is required"),
  numberOfEmployees: z.string().min(1, "Number of Employees is required"),
  natureOfBusiness: z.string().min(1, "Nature of Business is required"),
  cacDocument: z
    .any()
    .refine((file) => file instanceof File, "CAC Document is required"),
  incorporationDate: z.string().min(1, "Incorporation Date is required"),
});
